import { MFATokenConfirmPayload } from './../../../shared/cms/models/mfa-token-payload';
import { ProxyService } from './../../../core/services/proxy.service';
import { Component, OnInit, OnDestroy} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import { AlertService, ModalService, ConfirmModalService, AuthenticationService, OverlayService, ErrorCodesService,
  GtmService} from '@core/services';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UpdateTrigger } from '@shared/components/validation-message';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { AuthResponse } from '@core/redux/stores';
import { MFATokenPayload } from '@shared/cms/models/mfa-token-payload';
import { LoggingService } from '@core/services/logging.service';
import { ModalTrackingGtmDto, GtmExternal } from '@shared/models/configs/gtm.external';
import { MFAErrorcodeEnum } from '@core/services/mfa-errorcode-enum';

@Component({
  selector: 'app-signin-code',
  templateUrl: './signin-code.component.html',
  styleUrls: ['./signin-code.component.less'],
  providers: [AlertService]
})
export class SigninCodeComponent implements OnInit, OnDestroy {

  public signInCodeForm: UntypedFormGroup;
  public disableSignInButton: boolean;
  public loading: boolean;
  private subscriptions = new Subscription();
  public errorMessage: string;
  updateTrigger: any = UpdateTrigger;
  mfaToken: MFATokenPayload;


  constructor(
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private confirmModalService: ConfirmModalService,
    private router: Router,
    private authService: AuthenticationService,
    private overlayService: OverlayService,
    private proxy: ProxyService ,
    private logger: LoggingService,
    private gtmService: GtmService ) {
    this.disableSignInButton = true;
   }

  ngOnInit() {
    this.createForm();
    this.mfaToken = this.authService.getMFAToken();
    this.signInCodeForm.valueChanges.subscribe(() => {
      if (this.signInCodeForm.valid) {
        this.disableSignInButton = false;
      } else {
        this.disableSignInButton = true;
      }
    });


    this.subscriptions.add(
      this.confirmModalService.btnEvent.subscribe(
        (data: string) => {
          if (data === 'customerCare') {
            this.router.navigateByUrl('/contact-us');
          }
        }
      )
    );
  }

  createForm() {
    this.signInCodeForm = this.fb.group({
      code: new UntypedFormControl(null, [Validators.required])
    });
  }

  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  childClosed() {
    this.modalService.hideModal();
  }

  onCodeChange() {
    this.errorMessage = '';
  }

  onSubmit() {
    this.loading = true;
    const codeValue = this.signInCodeForm.controls.code.value;
    if (codeValue) {
      const mfaConfirmTokenPayload: MFATokenConfirmPayload = {
        token: this.mfaToken.token,
        code: codeValue
      };
      this.proxy.httpPost(ApiRoutes.MFA_CONFIRM_CODE, mfaConfirmTokenPayload).subscribe(
        (response) => {
          this.gtmService.sendEvent(GtmExternal.EVENT_NEW_DEVICE_SUCCESS);
          this.loading = false;
          const signInResponse = <AuthResponse>response.body.valueOf();
          this.authService.setUserData(signInResponse);
          this.modalService.hideModal();
          this.loading = false;
          this.disableSignInButton = false;
        },
        async (error) => {
          this.gtmService.sendEvent(GtmExternal.EVENT_NEW_DEVICE_ERROR);
          if (error.error.code === MFAErrorcodeEnum.MFAIncorrectCode) {
            this.errorMessage = ErrorCodesService.getErrorMessage(error.error.code, null);
            this.signInCodeForm.markAsPristine();
            this.signInCodeForm.markAsUntouched();
            this.loading = false;
          } else if (error.error.code === MFAErrorcodeEnum.InvalidMFAToken ||
            error.error.code === MFAErrorcodeEnum.MFATokenAlreadyVerified ||
            error.error.code === MFAErrorcodeEnum.MFATokenExpired ||
            error.error.code === MFAErrorcodeEnum.MFATokenLockedOut) {
            await this.authService.showOKModal(error.error.code);
            this.modalService.hideModal();
          }
          this.logger.logError(error);
        }
      );
    }

  }


  resendCode() {
    const gtmModalTracking = new ModalTrackingGtmDto();
    gtmModalTracking.pageName = GtmExternal.VALUE_SIGNIN;
    gtmModalTracking.clickText = GtmExternal.VALUE_CLICK_TEXT_RESEND_CODE;
    gtmModalTracking.event = GtmExternal.EVENT_CTA_CLICK;
    this.gtmService.sendModalEvent(gtmModalTracking);
    this.authService.requestMFACode(true);
    this.overlayService.displayOverlay('We\'ve sent a new code to your email.');
  }

  confirmCode() {
    this.authService.confirmMFACode(this.signInCodeForm.controls.code.value);
  }

  ngOnDestroy() {
    this.authService.setMFAToken({
      token: ''
    });
  }

}
